// extracted by mini-css-extract-plugin
export var author = "index-module--author--FLS18";
export var container = "index-module--container--ElfcN";
export var lavanya = "index-module--lavanya--GjMX0";
export var title = "index-module--title--BG4oL";